import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

class NavBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (window.location.pathname === "/") {
      return {
        hideNavItems: false,
      };
    } else if (window.location.pathname !== "/") {
      return {
        hideNavItems: true,
      };
    }
    return null;
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  // /*================================================================= */
  static getDerivedStateFromProps(props, state) {
    if (window.location.pathname === "/") {
      return {
        hideNavItems: false,
      };
    } else if (window.location.pathname !== "/") {
      return {
        hideNavItems: true,
      };
    }
    return null;
  }
  // /*================================================================= */

  componentDidMount() {
    console.log(this.props);
  }

  render() {
    // const {  displayEmail } = this.state;

    return (
      <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top shadow  mb-5 bg-white ">
        <Link
          class="navbar-brand as"
          style={{ textDecoration: "none", cursor: "pointer" }}
          to="/"
        >
          <b>
            Adnan Ahmed<i>'</i>
          </b>
        </Link>

        <button
          class="navbar-toggler bg-light "
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse text-center " id="navbarNav">
          <ul class="nav navbar-nav ml-auto">
            {/* <!-- THIS ml-auto is that 'below li links are align-right' --> */}
            <li class="nav-item navy">
              {this.state.hideNavItems === false ? (
                <span
                  class="nav-link "
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  onClick={this.props.handleClick}
                >
                  <b>Home</b>
                </span>
              ) : (
                <span
                  class="nav-link "
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  onClick={() => this.props.history.push("/")}
                >
                  <b>Home</b>
                </span>
              )}
            </li>
            <li class="nav-item navy">
              <span
                class="nav-link "
                style={{ textDecoration: "none", cursor: "pointer" }}
                // onClick={this.props.handleClick2}
                onClick={() => this.props.history.push("about")}
              >
                About Us
              </span>
            </li>
            <li class="nav-item navy">
              <span
                class={
                  this.state.hideNavItems === false
                    ? "nav-link"
                    : "nav-link disabled"
                }
                style={{ textDecoration: "none", cursor: "pointer" }}
                onClick={this.props.handleOnServices}
              >
                Services
              </span>
              {/* {this.state.hideNavItems === false ? (
                <span
                  class="nav-link "
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  onClick={this.props.handleOnServices}
                >
                  Services
                </span>
              ) : (
                <span
                  class="nav-link "
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  onClick={() => this.props.history.push("services")}
                >
                  Services
                </span>
              )} */}
            </li>
            {/* <li class="nav-item navy">
              <Link
                class="nav-link "
                style={{ textDecoration: "none", cursor: "pointer" }}
                to="/Books"
              >
                Book Shelf
              </Link>
            </li>
            <li class="nav-item navy">
              <Link
                class="nav-link "
                style={{ textDecoration: "none", cursor: "pointer" }}
                to="/Downloads"
              >
                Downloads
              </Link>
            </li> */}
            <li class="nav-item navy">
              <span
                class={
                  this.state.hideNavItems === false
                    ? "nav-link"
                    : "nav-link disabled"
                }
                style={{ textDecoration: "none", cursor: "pointer" }}
                onClick={this.props.handleOnClient}
              >
                Clients
              </span>
            </li>
            <li class="nav-item navy">
              {this.state.hideNavItems === false ? (
                <span
                  class={
                    this.state.hideNavItems === false
                      ? "nav-link"
                      : "nav-link disabled"
                  }
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  onClick={this.props.handleClick1}
                >
                  Portfolio
                </span>
              ) : (
                <span
                  class="nav-link "
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  onClick={() => this.props.history.push("allprojects")}
                >
                  Portfolio
                </span>
              )}
            </li>

            {/* <li class="nav-item navy">
              <span
                class="nav-link "
                style={{ textDecoration: "none", cursor: "pointer" }}
                onClick={() => this.props.history.push("details")}
              >
                Projects ALl
              </span>
            </li> */}

            <li class="nav-item navy1">
              {/* <span
                  class="nav-link "
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  Get In Touch
                </span> */}
              {/* <button
                style={{
                  backgroundColor: "rgb(118, 102, 223)",
                  color: "white",
                  // marginLeft: 10,
                }}
                class="btn btn-block"
                onClick={() => this.props.history.push("contact")}
              >
                Get In Touch
              </button> */}
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default withRouter(NavBar);
